<template>
  <slot v-if="isActive" />
</template>

<script lang="ts">
  import {
    defineComponent, inject, onMounted, onUnmounted,
    computed,
    watchEffect,
  } from 'vue'
  import {
    TabHeaderItem,
  } from './TabD'

  /**
   * 标签对应的面板
   */
  export default defineComponent({
    props: {
      /**
       * 标签的唯一 id 值
       */
      name: {
        type: String,
        required: true,
      },
      /**
       * 标签显示的文字
       */
      label: {
        type: String,
        required: true,
      },
      /**
       * 上标
       */
      count: {
        type: Number,
        required: false,
      },
      /**
       * 是否禁止
       */
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { slots }) {
      const controller = inject('tabs', {
        // eslint-disable-next-line
        addTab(item: TabHeaderItem) {},
        // eslint-disable-next-line
        removeTab(name: string) {},
        // eslint-disable-next-line
        updateTab(name: string, tabPaneProps: any) {},
        localTabName: { value: null },
      })

      onMounted(() => {
        controller.addTab({
          name: props.name,
          label: props.label,
          disabled: props.disabled,
          slots,
        })
      })

      onUnmounted(() => {
        controller.removeTab(props.name)
      })

      watchEffect(() => {
        controller.updateTab(props.name, props)
      })

      const isActive = computed(() => controller.localTabName.value === props.name)

      return {
        isActive,
      }
    },
  })
</script>
